import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from '../../common/Component';
import classList from '../../common/utils/classList';
import LoadingIndicator from '../../common/components/LoadingIndicator';
export default class HeaderList extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "$content", null);
    _defineProperty(this, "$scrollParent", null);
    _defineProperty(this, "boundScrollHandler", null);
  }
  view(vnode) {
    const {
      title,
      controls,
      hasItems,
      loading = false,
      emptyText,
      className,
      footer,
      ...attrs
    } = vnode.attrs;
    return m("div", Object.assign({
      className: classList('HeaderList', className)
    }, attrs), m("div", {
      className: "HeaderList-header"
    }, m("h4", {
      className: "App-titleControl App-titleControl--text"
    }, title), m("div", {
      className: "App-primaryControl"
    }, controls?.toArray())), m("div", {
      className: "HeaderList-content"
    }, loading ? m(LoadingIndicator, {
      className: "LoadingIndicator--block"
    }) : hasItems ? vnode.children : m("div", {
      className: "HeaderList-empty"
    }, emptyText)), !!footer && m("div", {
      className: "HeaderList-footer"
    }, footer()));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    if (this.attrs.loadMore) {
      this.$content = this.$('.HeaderList-content');

      // If we are on the notifications page, the window will be scrolling and not the $notifications element.
      this.$scrollParent = this.inPanel() ? this.$content : $(window);
      this.boundScrollHandler = this.scrollHandler.bind(this);
      this.$scrollParent.on('scroll', this.boundScrollHandler);
    }
  }
  onremove(vnode) {
    super.onremove(vnode);
    if (this.attrs.loadMore) {
      this.$scrollParent.off('scroll', this.boundScrollHandler);
    }
  }
  scrollHandler() {
    // Whole-page scroll events are listened to on `window`, but we need to get the actual
    // scrollHeight, scrollTop, and clientHeight from the document element.
    const scrollParent = this.inPanel() ? this.$scrollParent[0] : document.documentElement;

    // On very short screens, the scrollHeight + scrollTop might not reach the clientHeight
    // by a fraction of a pixel, so we compensate for that.
    const atBottom = Math.abs(scrollParent.scrollHeight - scrollParent.scrollTop - scrollParent.clientHeight) <= 1;
    if (atBottom) {
      this.attrs.loadMore?.();
    }
  }

  /**
   * If the NotificationList component isn't in a panel (e.g. on NotificationPage when mobile),
   * we need to listen to scroll events on the window, and get scroll state from the body.
   */
  inPanel() {
    return this.$content.css('overflow') === 'auto';
  }
}
flarum.reg.add('core', 'forum/components/HeaderList', HeaderList);